import { render, staticRenderFns } from "./Dispositivos.vue?vue&type=template&id=1b342dda&scoped=true"
import script from "./Dispositivos.vue?vue&type=script&lang=js"
export * from "./Dispositivos.vue?vue&type=script&lang=js"
import style0 from "./Dispositivos.vue?vue&type=style&index=0&id=1b342dda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b342dda",
  null
  
)

export default component.exports